export default __webpack_public_path__ + "static/media/monthly-planner.00a178b1.png";